import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import UiMeet3dGreetingBotDefaultValueRepository from "~/repository/UiMeet3d/UiMeet3dGreetingBotDefaultValueRepository";
import UiMeet3dGreetingBotDefaultValue from "~/modules/UiMeet3d/models/UiMeet3dGreetingBotDefaultValue";

class UiMeet3dGreetingBotDefaultValueStore extends NestStore {
  /**
   * @property {Array}
   */
  @observable uiMeet3dGreetingBotDefaultValues = [];

  uiMeet3dGreetingBotDefaultValueRepository = null;

  constructor() {
    super();

    this.uiMeet3dGreetingBotDefaultValueRepository = new UiMeet3dGreetingBotDefaultValueRepository();
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    return this.uiMeet3dGreetingBotDefaultValueRepository.fetch().then(response => {
      this.processEntities(response.data.uiMeet3dGreetingBotDefaultValues);
    });
  }

  @action
  processEntities(uiMeet3dGreetingBotDefaultValues = []) {
    this.uiMeet3dGreetingBotDefaultValues = [];

    uiMeet3dGreetingBotDefaultValues.forEach(uiMeet3dGreetingBotDefaultValueArray => {
      const uiMeet3dGreetingBotDefaultValue = new UiMeet3dGreetingBotDefaultValue(uiMeet3dGreetingBotDefaultValueArray);

      this.uiMeet3dGreetingBotDefaultValues.push(uiMeet3dGreetingBotDefaultValue);
    });
  }
}

export default UiMeet3dGreetingBotDefaultValueStore;
